import {Vue} from 'vue-property-decorator';
import {MAFUser} from '@/store/User/types';

// TODO: fix this file so these rules don't need to be disabled
/* tslint:disable:max-classes-per-file */
/* tslint:disable:class-name */

export interface OptionType {
    value: number | string;
    display: string;
}
export interface MarkerInjectable {
    map: google.maps.Map;
    googleMap: typeof google;
    position: Position;
}


export abstract class modalTemplate extends Vue {
    public abstract close(): void;
    public abstract save(): void;
}

export abstract class userMarker extends Vue {
    public abstract openChatWindow(user: MAFUser): void;
}

export abstract class mapDashboard extends Vue {
    public abstract setChat(user: MAFUser): void;
}

export interface RadioAvatarOption {
    selected: boolean;
    seed?: string;
    label?: string;
    option: string;
    disabled: boolean;
    active_btn: string;
    inactive_btn: string;
}

export interface RadioAvatar {
    type: string;
    options: RadioAvatarOption[];
    display: string;
    chance: string;
    prompt?: string;
}
